import ContainerSkeleton from './ContainerSceleton';

export default ContainerSkeleton;